<template>
  <div
    v-if="isOffline || showBanner"
    class="fixed inset-x-0 bottom-0 z-50 flex flex-col gap-2 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:left-auto sm:max-w-md"
  >
    <div
      v-if="isOffline"
      class="flex items-center gap-2 rounded-lg bg-amber-100 px-4 py-3 text-sm font-medium text-amber-900 shadow-lg ring-1 ring-amber-300 dark:bg-amber-950 dark:text-amber-100 dark:ring-amber-800"
      role="status"
    >
      <UIcon
        name="i-lucide-wifi-off"
        class="size-5 shrink-0"
      />
      Hors ligne : les données affichées peuvent ne pas être à jour.
    </div>

    <Transition
      enter-active-class="transition duration-500 ease-out"
      enter-from-class="translate-y-6 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
    >
      <div
        v-if="showBanner"
        class="overflow-hidden rounded-2xl bg-linear-to-br from-brand-blue-600 to-brand-blue-900 p-4 text-white shadow-2xl ring-1 ring-white/10"
      >
        <div class="flex items-start gap-3">
          <img
            src="/icons/volontaires-192.png"
            alt=""
            class="size-14 shrink-0 rounded-xl shadow-lg ring-2 ring-white/80"
          >
          <div class="min-w-0 flex-1">
            <p class="text-base font-bold leading-snug">
              Installe l'espace volontaire
            </p>
            <p class="mt-0.5 text-sm text-white/85">
              Accès en un tap, même sans réseau : annuaire, solde, commandes, tenues.
            </p>
          </div>
          <button
            type="button"
            class="-m-1 rounded-full p-1 text-white/70 hover:bg-white/10 hover:text-white"
            aria-label="Plus tard"
            @click="dismiss"
          >
            <UIcon
              name="i-lucide-x"
              class="size-5"
            />
          </button>
        </div>
        <div class="mt-3 flex gap-2">
          <UButton
            block
            color="neutral"
            class="bg-white font-semibold text-brand-blue-800 hover:bg-brand-blue-50"
            icon="i-lucide-download"
            :label="isIos ? 'Voir comment faire' : 'Installer'"
            @click="promptInstall"
          />
          <UButton
            color="neutral"
            variant="ghost"
            class="text-white hover:bg-white/10"
            label="Plus tard"
            @click="dismiss"
          />
        </div>
      </div>
    </Transition>
  </div>

  <PwaInstallGuide />
</template>

<script lang="ts" setup>
const { canInstall, isIos, isOffline, promptInstall, dismiss } = usePwa()
const route = useRoute()

// Apparition différée (le visiteur découvre d'abord l'app) ; l'accueil porte déjà sa grande carte d'installation.
const ready = ref(false)
onMounted(() => setTimeout(() => (ready.value = true), 4000))
const showBanner = computed(() => ready.value && canInstall.value && route.path.replace(/\/$/, '') !== '/volontaires')
</script>
